import React from "react";

const Services = () => {
  const services = [
    {
      category: "Corporations, Partnerships, LLCs",
      title: "ACCOUNTING SERVICES",
      description:
        "Whether it's reconciling accounts, correcting mistakes, or clearing up backlogs, we cover all your bookkeeping needs. Plus, you will enjoy clear, monthly financial reports to keep you informed.",
    },
    {
      category: "Individuals & Corporate Clients",
      title: "TAX SERVICES",
      description:
        "We will ensure your financial statements are ready for tax purposes and verify that you're fully compliant with all individual and corporate tax regulations so you can confidently approach tax season.",
    },
  ];

  return (
    <div className="relative z-10 bg-gray-50 py-12">
      {" "}
      {/* Added padding top and bottom */}
      <div className="max-w-7xl mx-auto px-8">
        {" "}
        {/* Increased horizontal padding */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 -mt-20">
          {" "}
          {/* Increased gap */}
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-12 hover:shadow-lg transition-shadow shadow-md" /* Increased padding */
            >
              <div className="h-full flex flex-col">
                <div className="text-gray-900 text-sm font-medium mb-3">
                  {service.category}
                </div>
                <h3 className="text-[30px] font-bold text-gray-900 mb-6">
                  {" "}
                  {/* Increased bottom margin */}
                  {service.title}
                </h3>
                <p className="text-gray-600 text-[20px] leading-relaxed text-left">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
